import styled from 'styled-components';

export const UiModal = styled.div`
`;

export const UiFigureContainer = styled.div`
  color: #242C3F;
  text-align: center;
`;